"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _liveAnnouncer = require("../live-announcer");

var _screenReaderOnly = require("../screen-reader-only");

var _utils = require("../utils");

var _constants = require("./constants");

var _datePickerCalendar = require("./date-picker-calendar");

var _propTypes = require("./popup-date-picker/popup-date-range-picker/propTypes");

var _propTypes2 = require("./propTypes");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["name", "id", "startValue", "endValue", "defaultStartValue", "defaultEndValue", "onChange", "initialView", "handleDateSelection", "shouldFocusOnStartDate", "locale", "weekStartDay", "aria-label", "ariaLabelsForSelectedDate", "dateMarkerLegend"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var DateRangePickerWithoutDocs = function DateRangePickerWithoutDocs(_ref) {
  var name = _ref.name,
      id = _ref.id,
      startValue = _ref.startValue,
      endValue = _ref.endValue,
      defaultStartValue = _ref.defaultStartValue,
      defaultEndValue = _ref.defaultEndValue,
      onChange = _ref.onChange,
      initialViewProp = _ref.initialView,
      handleDateSelection = _ref.handleDateSelection,
      _ref$shouldFocusOnSta = _ref.shouldFocusOnStartDate,
      shouldFocusOnStartDate = _ref$shouldFocusOnSta === void 0 ? _constants.dateRangePickerDefaultProps.shouldFocusOnStartDate : _ref$shouldFocusOnSta,
      locale = _ref.locale,
      weekStartDay = _ref.weekStartDay,
      _ref$ariaLabel = _ref['aria-label'],
      ariaLabel = _ref$ariaLabel === void 0 ? _constants.dateRangePickerDefaultProps['aria-label'] : _ref$ariaLabel,
      _ref$ariaLabelsForSel = _ref.ariaLabelsForSelectedDate,
      ariaLabelsForSelectedDate = _ref$ariaLabelsForSel === void 0 ? _constants.dateRangePickerDefaultProps.ariaLabelsForSelectedDate : _ref$ariaLabelsForSel,
      dateMarkerLegend = _ref.dateMarkerLegend,
      internalProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      stencilLocale = _useContext.locale;

  if (!locale) {
    locale = stencilLocale;
  }

  if (!weekStartDay) {
    weekStartDay = (0, _utils2.getWeekStartDay)(locale);
  }

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      selectedStartDateContext = _useState2[0],
      setSelectedStartDateContext = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectedEndDateContext = _useState4[0],
      setSelectedEndDateContext = _useState4[1];

  var initialSelectionStart = (0, _utils2.stringToDate)(startValue || defaultStartValue || undefined);
  var initialSelectionEnd = (0, _utils2.stringToDate)(endValue || defaultEndValue || undefined);
  var initialView = (0, _utils2.getInitialView)({
    initialSelection: initialSelectionStart,
    initialViewProp: initialViewProp
  });

  var _useState5 = (0, _react.useState)(initialView),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      currentView = _useState6[0],
      setCurrentView = _useState6[1];

  var _useState7 = (0, _react.useState)(initialSelectionStart),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      stateStartValue = _useState8[0],
      setStateStartValue = _useState8[1];

  var _useState9 = (0, _react.useState)(initialSelectionEnd),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      stateEndValue = _useState10[0],
      setStateEndValue = _useState10[1];

  var selectedStartDate = startValue !== undefined ? (0, _utils2.stringToDate)(startValue) : stateStartValue;
  var selectedEndDate = endValue !== undefined ? (0, _utils2.stringToDate)(endValue) : stateEndValue;
  var announceSelectionContext = (0, _react.useCallback)(function (_ref2) {
    var isStartDate = _ref2.isStartDate,
        isEndDate = _ref2.isEndDate;
    setSelectedStartDateContext(isStartDate ? ariaLabelsForSelectedDate.startDate || '' : '');
    setSelectedEndDateContext(isEndDate ? ariaLabelsForSelectedDate.endDate || '' : '');
  }, [setSelectedEndDateContext, setSelectedStartDateContext, ariaLabelsForSelectedDate.startDate, ariaLabelsForSelectedDate.endDate]);

  var defaultHandleDateSelection = function defaultHandleDateSelection(date) {
    // If selecting a date for the first time
    // Or if two dates are already selected (changing the selection)
    if (!selectedStartDate || selectedStartDate && selectedEndDate) {
      setStateStartValue(date);
      setStateEndValue(undefined);
      announceSelectionContext({
        isStartDate: true
      });
      !!onChange && onChange((0, _utils2.dateToString)(date), '');
    } // If a start date is already selected, and the end date is before the start date
    else if (selectedStartDate && date.getTime() < selectedStartDate.getTime()) {
      setStateStartValue(date);
      announceSelectionContext({
        isStartDate: true,
        isEndDate: false
      });
      !!onChange && onChange((0, _utils2.dateToString)(date), '');
    } // If making an end date selection
    else {
      setStateStartValue(selectedStartDate);
      setStateEndValue(date);
      announceSelectionContext({
        isStartDate: false,
        isEndDate: true
      });
      !!onChange && onChange((0, _utils2.dateToString)(selectedStartDate), (0, _utils2.dateToString)(date));
    }

    setCurrentView({
      year: date.getUTCFullYear(),
      month: date.getUTCMonth()
    });
  }; // Update the view to show the start date if the controlled start date changes


  (0, _react.useEffect)(function () {
    var parsedDate = (0, _utils2.stringToDate)(startValue);

    if (parsedDate !== undefined) {
      var year = parsedDate.getUTCFullYear();
      var month = parsedDate.getUTCMonth();

      if (year !== currentView.year || month !== currentView.month) {
        setCurrentView({
          year: parsedDate.getUTCFullYear(),
          month: parsedDate.getUTCMonth()
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [startValue]); // Update the view to show the end date if the controlled end date changes

  (0, _react.useEffect)(function () {
    var parsedDate = (0, _utils2.stringToDate)(endValue);

    if (parsedDate !== undefined && !shouldFocusOnStartDate) {
      var year = parsedDate.getUTCFullYear();
      var month = parsedDate.getUTCMonth();

      if (year !== currentView.year || month !== currentView.month) {
        setCurrentView({
          year: parsedDate.getUTCFullYear(),
          month: parsedDate.getUTCMonth()
        });
      }
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [endValue, shouldFocusOnStartDate]); // Clear aria live regions so that screen readers can re-announce

  (0, _react.useEffect)(function () {
    var timer = setTimeout(function () {
      announceSelectionContext({
        isStartDate: false,
        isEndDate: false
      });
    }, _liveAnnouncer.CLEAR_REGION_TIMEOUT);
    return function () {
      clearTimeout(timer);
    };
  }, [stateStartValue, stateEndValue, announceSelectionContext]);
  var selectedDatesAsString = [selectedStartDate, selectedEndDate].map(function (date) {
    return (0, _utils2.dateToString)(date);
  }).join(','); // Choose the default date selection handler if is not set

  var dateSelectionFunction = function dateSelectionFunction(date) {
    return !!handleDateSelection ? handleDateSelection({
      date: date,
      setStateStartValue: setStateStartValue,
      setStateEndValue: setStateEndValue,
      announceSelectionContext: announceSelectionContext,
      selectedStartDate: selectedStartDate,
      selectedEndDate: selectedEndDate,
      onChange: onChange
    }) : defaultHandleDateSelection(date);
  };

  return (0, _core.jsx)("div", {
    "data-test-component": "StencilDateRangePicker"
  }, (id || name) && (0, _core.jsx)("input", {
    type: "hidden",
    id: id,
    name: name,
    value: selectedDatesAsString
  }), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    "aria-live": "polite",
    role: "status"
  }, selectedStartDateContext), (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    "aria-live": "polite",
    role: "status"
  }, selectedEndDateContext), (0, _core.jsx)(_datePickerCalendar.DatePickerCalendar, (0, _extends2.default)({
    year: currentView.year,
    month: currentView.month,
    selectionStart: selectedStartDate,
    selectionEnd: selectedEndDate,
    goToMonth: function goToMonth(month, year) {
      return setCurrentView({
        month: month,
        year: year
      });
    },
    onDateSelected: dateSelectionFunction,
    locale: locale,
    weekStartDay: weekStartDay,
    "aria-label": ariaLabel,
    ariaLabelsForSelectedDate: ariaLabelsForSelectedDate
  }, internalProps)), dateMarkerLegend);
};

var DateRangePickerWithDocs = (0, _stencilReactDesc.describe)(DateRangePickerWithoutDocs).description('Interactive calendar for choosing a range of dates.');
DateRangePickerWithDocs.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _propTypes2.datePickerBasePropTypes), _propTypes.dateRangePickerPropTypes), {}, {
  startValue: _stencilReactDesc.PropTypes.string.description('The start date of the currently selected range as an ISO formatted string, used when the component is being controlled.'),
  endValue: _stencilReactDesc.PropTypes.string.description('The end date of the currently selected range as an ISO formatted string, used when the component is being controlled.')
});
var DateRangePicker = (0, _utils.withTestAttributes)({})(DateRangePickerWithDocs);
DateRangePicker.defaultProps = _objectSpread({}, _constants.dateRangePickerDefaultProps);
DateRangePicker.displayName = 'DateRangePicker';
var _default = DateRangePicker;
exports.default = _default;